<template>
  <div v-if="item.isDescriptor" class="descriptor-cell">
    <!-- expanded drilldown parents in horizontal-axis views render as a slim
         band with the description suppressed -->
    <template v-if="item.suppressDescriptor"></template>
    <template v-else-if="item.canEdit">
      <textarea
        ref="descEdit"
        class="descriptor-edit"
        :readonly="!descriptorEditing"
        :value="descriptorEditing ? descriptorText : (descriptorSavedText !== null ? descriptorSavedText : (item.title || ''))"
        :placeholder="'Add ' + (item.descriptorNode?.label ? item.descriptorNode.label + ' ' : '') + 'Description...'"
        :title="item.descriptorNode ? 'Edit description for: ' + item.descriptorNode.name : ''"
        @mousedown="onDescriptorPointerDown"
        @focus="startDescriptorEdit"
        @blur="onDescriptorBlur"
        @input="descriptorText = $event.target.value"
        @keydown.esc.stop.prevent="cancelDescriptorEdit"
        @keydown.ctrl.83.stop.prevent="saveDescriptorEdit"
        @click.stop="startDescriptorEdit"
      ></textarea>
      <div v-if="descriptorEditing" class="descriptor-actions">
        <v-btn x-small depressed color="primary" title="Save (Ctrl+S)"
          @mousedown.native.prevent @click.stop="saveDescriptorEdit">Save</v-btn>
        <v-btn x-small depressed title="Cancel (Esc)"
          @mousedown.native.prevent @click.stop="cancelDescriptorEdit">Cancel</v-btn>
      </div>
    </template>
    <div v-else-if="item.notAvailable" class="descriptor-unavailable">Descriptions are not available at this level</div>
    <div v-else class="descriptor-read" :title="item.title">{{ item.title }}</div>
  </div>
  <div
    v-else-if="item.doc_id"
    :title="item.title + ': Click to view ' + catalogueDocType.docType"
    @contextmenu="$emit('openDocActionsMenuContext', $event)"
  >
    <DocSummary
      :doc_id="item.doc_id"
      :text="item.title"
      :searchTerms="searchTerms"
      @openDocument="$emit('openDocument', $event)"
      @copyDocument="$emit('copyDocument', $event)"
    ></DocSummary>
    <!-- <span :title="item.title">{{ item.title }}</span> -->
    <v-badge
      color="red"
      v-if="item.match_count && 1 === 0"
      :content="item.match_count"
      offset-y="10"
    >
      <v-icon
        class="float-fight"
        color="blue"
        small
        title="click to compare similar docments"
        @click="$emit('showMatches')"
        >mdi-content-duplicate</v-icon
      >
    </v-badge>
  </div>
  <v-checkbox
    v-else-if="item.isSelectable"
    :label="item.title"
    style="margin-top: 0; text-align: left"
    @click="$emit('selectJob')"
    color="green"
  >
    <!-- v-model="item.selected" -->
  </v-checkbox>
  <div v-else-if="indentNode" style="position: relative">
    <div
      style="
        margin-left: 50%;
        border-left: 1px solid grey;
        height: 10px;
        width: 1px;
        position: relative;
        top: 0;
      "
    ></div>
    <cHierarchyNodeDisplay
      v-if="item.node"
      :node="item.node"
      :nodeActionsAlignment="item.nodeActionsAlignment"
      :nodeSelectable="item.nodeSelectable"
      :searchTerms="searchTerms"
      @action="$emit('doMenuAction', $event)"
    ></cHierarchyNodeDisplay>
  </div>
  <cHierarchyNodeDisplay
    v-else-if="item.node"
    :node="item.node"
    displayPlain
    :isLink="item.node.level > 1 && (item.node.isLeaf || item.node.level === item.node.levels?.length)"
    :customStyle="item.displayStyle"
    :nodeActionsAlignment="item.nodeActionsAlignment"
    :nodeSelectable="item.nodeSelectable"
    :searchTerms="searchTerms"
    :hideNodeActions="hideNodeActions"
    @action="$emit('doMenuAction', $event)"
    @nodeSelected="$emit('nodeSelected', item.node)"
    @viewNodeDoc="$emit('viewNodeDoc', $event, item)"
  ></cHierarchyNodeDisplay>
  <div v-else :title="item.name + ': ' + item.title" class="text-cell"
    v-html="utils.highlightSearchTerms(item.title, searchTerms)">
  </div>
    <!-- {{ item.title }} -->
</template>

<script>
import cHierarchyNodeDisplay from "@/components/hierarchy/cHierarchyNodeDisplay";
import DocSummary from "@/components/common/DocViewPopUp";
import utils from "@/common/utils.js";

export default {
  name: "DimensionDisplay",
  components: {
    cHierarchyNodeDisplay,
    DocSummary,
  },
  props: {
    item: { type: Object, required: false },
    catalogueDocType: { type: Object, required: false },
    indentNode: Boolean,
    searchTerms: { type: [], required: false },
    hideNodeActions: { type: Boolean, required: false },
  },
  data: function () {
    return {
      response: null,
      utils: utils,
      descriptorEditing: false,
      descriptorText: "",
      descriptorScrollbarPress: false,
      // holds the just-saved text until the parent refreshes item.title,
      // so the cell never flashes back to the old description
      descriptorSavedText: null,
    };
  },
  watch: {
    "item.title"() {
      this.descriptorSavedText = null;
    },
  },
  computed: {},
  created() {},
  methods: {
    // a press on the textarea's own scrollbar (outside the client box) must
    // scroll, not start editing
    onDescriptorPointerDown(e) {
      this.descriptorScrollbarPress =
        e.offsetX >= e.target.clientWidth || e.offsetY >= e.target.clientHeight;
    },
    startDescriptorEdit() {
      if (this.descriptorEditing || this.descriptorScrollbarPress) return;
      this.descriptorText = this.item.title || "";
      this.descriptorEditing = true;
    },
    saveDescriptorEdit() {
      if (!this.descriptorEditing) return;
      this.descriptorEditing = false;
      if (this.descriptorText !== (this.item.title || "")) {
        this.descriptorSavedText = this.descriptorText;
        this.$emit("saveDescriptor", this.item, this.descriptorText);
      }
      this.$refs.descEdit?.blur();
    },
    cancelDescriptorEdit() {
      this.descriptorEditing = false;
      this.descriptorText = this.item.title || "";
      this.$refs.descEdit?.blur();
    },
    onDescriptorBlur() {
      // clicking away with nothing changed just leaves edit mode; with
      // changes pending the Save/Cancel actions stay up
      if (this.descriptorEditing && this.descriptorText === (this.item.title || ""))
        this.cancelDescriptorEdit();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/vars";

.text-cell {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
    line-height: 20.83px;
    font-family: "DM Sans" !important;
    font-weight: 400;
    font-size: 14px;
    letter-spacing: 0.5px;
}
/* the cell is absolutely positioned against its column (.descriptor-col) so it
   fills the full row height - including merged group cells - without its
   content ever stretching the row past the other columns; the insets stand in
   for the 12px .row-header cell padding */
.descriptor-cell {
  position: absolute;
  top: 12px;
  bottom: 12px;
  left: 12px;
  right: 8px;
  display: flex;
  flex-direction: row;
}
.descriptor-edit,
.descriptor-read {
  display: block;
  width: 100%;
  max-height: 100%;
  overflow-y: auto;
  font-family: "DM Sans", sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  letter-spacing: 0.3px;
  white-space: pre-wrap;
}
.descriptor-edit {
  flex: 1 1 auto;
  min-width: 0;
  resize: none;
  border: 1px solid transparent;
  border-radius: 4px;
  padding: 2px 4px;
  background-color: inherit;
  color: inherit;
}
.descriptor-edit:hover {
  border-color: #bcd4d0;
}
.descriptor-unavailable {
  font-family: "DM Sans", sans-serif;
  font-style: italic;
  font-size: 12px;
  color: #9e9e9e;
  align-self: center;
}
.descriptor-edit:focus {
  outline: none;
  border-color: #7aa8a1;
  background-color: white;
}
/* stacked to the right of the textarea so the actions never mask the text -
   the textarea narrows to give up the column they need while editing */
.descriptor-actions {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 4px;
  padding-left: 4px;
}
</style>
